module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card no-block memory-editor"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "flat": "",
      "items": _vm.bases,
      "label": "Registers"
    },
    on: {
      "change": _vm.update
    },
    model: {
      value: (_vm.base),
      callback: function($$v) {
        _vm.base = $$v
      },
      expression: "base"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "memory-editor-body",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('code-mirror', {
    attrs: {
      "value": _vm.textContent,
      "options": _vm.editorOptions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606d513a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/craps/CrapsRegistersEditor.vue
// module id = 1198
// module chunks = 1